import { ICONS_URL } from "../lib/constants";

class SvgIcon extends HTMLElement {
  #svg: SVGElement

  constructor() {
    super();
    this.#svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    this.appendChild(this.#svg);
  }

  static get observedAttributes(): string[] {
    return ['icon'];
  }

  attributeChangedCallback(name: string, oldValue: string, newValue: string): void {
    if (name === 'icon') {
      this.#svg.innerHTML = `
        <use xlink:href="${ICONS_URL}#${newValue}"></use>
      `;
    }
  }
}

customElements.define('svg-icon', SvgIcon);